import ModalStatusIcon from "./ModalStatusIcon";

export default ModalStatusIcon;
